// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","value":"styles_value__od11H","metric":"styles_metric__BHRw9","postfix":"styles_postfix__echXX","fadeIn":"styles_fadeIn__HsLsK"};